import { ColDef } from "ag-grid-community";
import type { Suspect as ApiSuspect } from "../../../../../api/suspects";
import { suspectMapping } from "./shared";
import { DisplayNameCellRenderer } from "./display-name-cell";

export type SuspectRowData = ApiSuspect & {
  condition: string;
  code: string;
  displayName: string;
  logicTooltip: string;
};

/**
 * Generate table data for suspects section using API data
 */
export const suspectTableData = ({ suspects }: { suspects?: ApiSuspect[] } = {}) => {
  const columnDefs: ColDef<SuspectRowData>[] = [
    { field: "id", hide: true },
    { field: "condition", flex: 2 },
    { field: "code", flex: 1, headerName: "ICD Code" },
    {
      field: "displayName",
      flex: 1,
      headerName: "Suspect Group",
      cellRenderer: DisplayNameCellRenderer,
    },
    { field: "logicTooltip", hide: true },
  ];

  const rowData =
    suspects?.map(suspect => {
      const mapping = suspectMapping[suspect.group] || {
        displayName: suspect.group,
        logicTooltip: "No additional information available",
      };

      return {
        ...suspect,
        condition: suspect.icd10ShortDescription,
        code: suspect.icd10Code,
        displayName: mapping.displayName,
        logicTooltip: mapping.logicTooltip,
      };
    }) || [];

  return { columnDefs, rowData };
};
